import { selectSupport } from '~/components/brand/ducks/selectors';
import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import { authenticationSelector } from '~/components/authentication/ducks/selectors';
import { selectAccount } from '~/components/account/ducks';
import { clearDixaUser, updateDixaUser } from '~/components/support/ducks/index-dixa';

const DixaUserIdentifier = () => {
	const { supportLoaded } = useSelector(selectSupport);
	const authenticated = useSelector(authenticationSelector);
	const account = useSelector(selectAccount);

	useEffect(() => {
		if (supportLoaded) {
			if (authenticated && account.email && account.firstName && account.lastName) {
				const userData = {
					email: account.email,
					name: `${account.firstName} ${account.lastName}`
				};

				updateDixaUser(userData);
			} else {
				clearDixaUser();
			}
		}
	}, [supportLoaded, authenticated, account]);

	return null;
};

export default DixaUserIdentifier;
